module.exports = __webpack_public_path__ + "static/media/all_welds_1.ce078dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/all_welds_1.jpg
// module id = 1877
// module chunks = 0